<template>
  <div v-loading="loading">
  </div>
</template>
<script>
import * as api from '../api/api'
import * as constants from '../api/constant'
export default {
  name: 'login',
  data () {
    return {
      loading: true
    }
  },
  mounted () {
    this.logout()
  },
  methods: {
    logout () {
      api.axiosRequest(api.urlList.logout)
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          api.removeAccessToken()
          this.$store.commit(constants.MSGBADGE, null)
          this.$store.commit(constants.USERINFO, null)
          this.$store.commit(constants.FACE, null)
          this.$store.commit(constants.H5CONFIG, null)
          this.$router.replace('/login')
        })
    }
  }
}
</script>
